export {
  /**
   * Provides static strings that are flexible per brand.
   */
  useDisplayText,
} from './use-display-text';
